import { MenuProps } from '@szhsin/react-menu'

import ButtonWithDropdown from 'common/components/ButtonWithDropdown'
import { ReorderDown } from 'common/icons'

export type SortOptions = { property: string; isAscending: boolean }

type Props = {
  onSortClick: (value: SortOptions) => void
} & Partial<MenuProps>

const sortOptions = [
  {
    label: 'Recent',
    value: {
      property: 'lastModified',
      isAscending: false,
    },
  },
  {
    label: 'Oldest',
    value: {
      property: 'lastModified',
      isAscending: true,
    },
  },
  {
    label: 'Date created',
    value: { property: 'createdDate', isAscending: true },
  },
  {
    label: 'Ascending',
    value: { property: 'name', isAscending: true },
  },
  {
    label: 'Descending',
    value: { property: 'name', isAscending: false },
  },
]

const SortMenu = ({ onSortClick }: Props) => {
  return (
    <ButtonWithDropdown
      overlayClassName="capitalize"
      data-cy="sort_menu"
      aria-label="sort menu"
      suffixIcon={false}
      options={sortOptions
        .map(({ label, value }) => [
          {
            key: `${value.property}-${value.isAscending}`,
            label: label,
            onClick: () => onSortClick(value),
          },
        ])
        .flat()}
      prefixIcon={<ReorderDown />}
    ></ButtonWithDropdown>
  )
}

export default SortMenu
